import { Head, useForm } from '@inertiajs/react'
import ProfileForm, { type ProfileData } from '../../components/ProfileForm'
import { eyebrowClass } from '../../components/ui'

type ServerProfile = { [K in keyof ProfileData]: string | number | null }

function toFormData(profile: ServerProfile): ProfileData {
  return {
    swing_speed_mph: profile.swing_speed_mph?.toString() ?? '',
    attack_angle_deg: profile.attack_angle_deg?.toString() ?? '',
    typical_miss: profile.typical_miss?.toString() ?? '',
    current_driver_head: profile.current_driver_head?.toString() ?? '',
    current_driver_shaft: profile.current_driver_shaft?.toString() ?? '',
    handicap: profile.handicap?.toString() ?? '',
    goals: profile.goals?.toString() ?? '',
  }
}

export default function ProfilesEdit({ profile, miss_options }: { profile: ServerProfile; miss_options: string[] }) {
  const form = useForm<ProfileData>(toFormData(profile))

  return (
    <>
      <Head title="My game" />
      <header className="mb-8 sm:mb-10">
        <p className={`${eyebrowClass} text-muted`}>Your starting point</p>
        <h1 className="mt-3 font-serif text-4xl tracking-tight sm:text-5xl">My game</h1>
        <p className="mt-4 max-w-xl text-base leading-7 text-muted">A little context goes a long way. Save what you know about your swing, your equipment, and where you’d like to take your game.</p>
      </header>
      <div className="grid items-start gap-8 lg:grid-cols-[1fr_240px] lg:gap-10">
        <ProfileForm
          data={form.data}
          errors={form.errors}
          missOptions={miss_options}
          processing={form.processing}
          onChange={(field, value) => form.setData(field, value)}
          onSubmit={() => form.patch('/profile')}
        />
        <aside className="rounded-xl border border-line bg-soft p-6" aria-labelledby="profile-note">
          <p className={`${eyebrowClass} text-brand`}>No perfect numbers needed</p>
          <h2 id="profile-note" className="mt-4 font-serif text-2xl">Start where you are.</h2>
          <p className="mt-3 text-sm leading-7 text-muted">You don’t need a launch monitor or a complete equipment list to get started. A question or a goal is enough for your first profile.</p>
          <p className="mt-5 border-t border-line pt-4 text-xs leading-6 text-muted">Your profile and session uploads are available now. The advisor is still in development.</p>
        </aside>
      </div>
    </>
  )
}
